module.exports = "build/assets/mobileProblemWave.8e65e8e5.png";